import { z } from "zod";

import { RulesObjectSchema } from "@features/rules-section/model/schemas";

import { TitleWithIconSchema } from "@shared/content-types/schemas/pageHero.schema";
import { SeoSchema } from "@shared/content-types/schemas/seo.schema";
import { UniversalGallerySectionSchema } from "@shared/ui/universal-gallery";

import { TrailSchema } from "@/_pages/single-trail/model/schemas";

export const TrailsPageSchema = z.object({
  id: z.number().int().positive(),
  documentId: z.string().min(1),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  publishedAt: z.string().datetime().optional(),
  titleWithIcon: TitleWithIconSchema,
  rulesSection: RulesObjectSchema.optional().nullable(),
  seo: SeoSchema.optional().nullable(),
  gallerySection: UniversalGallerySectionSchema.base.optional().nullable(),
});

export const TrailsPageDtoSchema = z.object({
  data: TrailsPageSchema,
});

export const TrailsDtoSchema = z.object({
  data: z.array(TrailSchema).min(0),
  meta: z.object({
    pagination: z.object({
      page: z.number(),
      pageSize: z.number(),
      pageCount: z.number(),
      total: z.number(),
    }),
  }),
});
